import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const LeadHubspotReferenceSchema = z
    .object({
        contact: z.string(),
        company: z.string(),
    })
    .strict();

export class LeadHubspotReference extends FromSchema(LeadHubspotReferenceSchema) {
    contact: string;
    company: string;
}
